module.exports = __webpack_public_path__ + "img/icon_member@2x.8af2d236.png";